import React, { useState, useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Sidebar from './sidebar';
import Header from './header';
import { Toaster } from 'react-hot-toast';

export const UserLayout: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="flex h-screen font-poppins">
      {/* Sidebar */}
      <Sidebar
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={() => setIsMobileMenuOpen(false)}
      />

      {/* Main content */}
      <div className="flex flex-1 flex-col lg:ml-[260px]">
        <Header onMenuClick={() => setIsMobileMenuOpen(true)} />

        {/* Ici on applique le fond dégradé + padding général */}
        <main className="flex-1 overflow-y-auto persosrcollbar bg-gradient-to-br from-black to-green-950 p-2 py-6 sm:p-8 w-full mx-auto ">
          <Outlet />
        </main>
      </div>

      <Toaster position="top-right" />
    </div>
  );
};

export default UserLayout;